"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_CREATE_TIME = exports.ERROR_GET_NOW = exports.ERROR_AVAILABLE_BALANCE = exports.ERROR_ENROLL_AND_SCRAPE_TOKENS = exports.ERROR_SCRAPE_TOKENS = exports.ERROR_GET_KEEPER_LIST = void 0;
exports.ERROR_GET_KEEPER_LIST = 'Error getting keeperlist';
exports.ERROR_SCRAPE_TOKENS = 'Error scraping tokens';
exports.ERROR_ENROLL_AND_SCRAPE_TOKENS = 'Error enrolling address and scraping tokens';
exports.ERROR_AVAILABLE_BALANCE = 'Error getting available balance';
exports.ERROR_GET_NOW = 'Error getting current date and time';
exports.ERROR_CREATE_TIME = 'Error getting created date and time';
